import { useAccountManagerByLocale } from '@/lib/hooks/useAccountManager';
import { IProductAccountManager } from '@/lib/types/api';
import Image from 'next/image';

// TODO: refactor those components
export function ProfileAM({
  accountManager,
}: {
  accountManager?: IProductAccountManager;
}) {
  return accountManager ? (
    <Profile
      photoUrl={accountManager.profile_picture}
      name={accountManager.name}
      position={accountManager.position ?? 'Account Manager'}
      email={accountManager?.email}
      phone={accountManager?.phone}
      linkedin={accountManager?.linkedin}
    />
  ) : null;
}

export function Profile({
  name,
  position,
  phone,
  email,
  photoUrl,
  linkedin,
}: {
  name: string;
  position: string;
  email: string;
  photoUrl: string;
  phone: string;
  linkedin?: string;
}) {
  return (
    <div className='mx-auto flex max-w-sm flex-col items-center space-y-2'>
      <div className='relative h-36 w-36 overflow-hidden rounded-full border-4 border-brand'>
        <Image
          src={photoUrl}
          alt={name}
          fill
          className='rounded object-cover'
        />
      </div>
      <h5 className='text-center font-semibold'>{name}</h5>
      <h5 className='text-center font-semibold'>{position}</h5>
      <div className=''>
        <h5 className='text-center'>
          M:{' '}
          <a href={'tel:' + phone} className='text-blue-800 underline'>
            {phone}
          </a>
        </h5>
        <h5 className='text-center'>
          @:{' '}
          <a
            className='text-blue-800 underline underline-offset-2'
            href={'mailto:' + email}
            target='_blank'
            rel='noreferrer'
          >
            {email}
          </a>
        </h5>
      </div>
      <div className='flex'>
        <a
          href={
            'https://api.whatsapp.com/send?phone=' +
            phone.replace(/(\+|\s)/g, '')
          }
          target='_blank'
          rel='noreferrer'
          aria-label='whatsapp'
        >
          <div className='relative h-8 w-8'>
            <Image
              src={'/mygindumac/whatsapp.svg'}
              className='object-cover'
              fill
              alt='whatsapp'
            />
          </div>
        </a>
        {linkedin && (
          <a
            href={linkedin}
            target='_blank'
            rel='noreferrer'
            aria-label='linkedin'
          >
            <div className='relative h-8 w-8'>
              <Image
                src={'/mygindumac/linkedin.svg'}
                className='object-cover'
                fill
                alt='whatsapp'
              />
            </div>
          </a>
        )}
      </div>
    </div>
  );
}

export function AccountManagerRow() {
  const { data: accountManager, isLoading } = useAccountManagerByLocale();
  return (
    <div className='mx-auto mb-24 flex max-w-2xl flex-col items-center justify-center space-y-2 xl:flex-row'>
      {isLoading ? (
        <LoadingAccountManager />
      ) : (
        <AccountManagerRow2 accountManager={accountManager} />
      )}
    </div>
  );
}

export function AccountManagerRow2({
  accountManager,
}: {
  accountManager: IProductAccountManager;
}) {
  return (
    <>
      <div
        className={
          'relative h-44 w-44 overflow-hidden rounded-full border-8 border-brand-200 lg:h-52 lg:w-52'
        }
      >
        <Image
          src={accountManager.profile_picture}
          alt={accountManager.name}
          fill
          className='rounded object-cover'
        />
      </div>
      <div className=' ml-4 flex flex-col items-center xl:items-start'>
        <h5 className='text-xl font-semibold'>{accountManager.name}</h5>
        <h5 className='text-center text-xl font-semibold xl:text-left'>
          {accountManager.position}
        </h5>
        <div className='my-2 space-y-2 text-center xl:text-left'>
          <h5>
            <a
              href={'tel:' + accountManager.phone}
              className='text-xl text-blue-800 underline'
            >
              {accountManager.phone}
            </a>
          </h5>
          <h5>
            <a
              className='text-xl text-blue-800 underline underline-offset-2'
              href={'mailto:' + accountManager.email}
              target='_blank'
              rel='noreferrer'
            >
              {accountManager.email}
            </a>
          </h5>
        </div>
        <div className='flex'>
          <a
            href={
              'https://api.whatsapp.com/send?phone=' +
              accountManager.phone.replace(/(\+|\s)/g, '')
            }
            target='_blank'
            rel='noreferrer'
            aria-label='whatsapp'
          >
            <div className='relative h-8 w-8'>
              <Image
                src={'/mygindumac/whatsapp.svg'}
                className='object-cover'
                fill
                alt='whatsapp'
              />
            </div>
          </a>
          {accountManager?.linkedin && (
            <a
              href={accountManager?.linkedin}
              target='_blank'
              rel='noreferrer'
              aria-label='linkedin'
            >
              <div className='relative h-8 w-8'>
                <Image
                  src={'/mygindumac/linkedin.svg'}
                  className='object-cover'
                  fill
                  alt='whatsapp'
                />
              </div>
            </a>
          )}
        </div>
      </div>
    </>
  );
}

function LoadingAccountManager() {
  return (
    <>
      <div
        className={
          'relative h-44 w-44 animate-pulse overflow-hidden rounded-full bg-gray-300 lg:h-52 lg:w-52'
        }
      />
      <div className=' ml-4 flex flex-col items-center xl:items-start'>
        <div className='my-2 space-y-2 text-center xl:text-left'>
          <h5 className='h-4 w-32 bg-gray-300 text-xl text-blue-800 underline' />
          <h5 className='h-8 w-52 animate-pulse bg-gray-300 text-center text-xl font-semibold xl:text-left' />
          <h5 className='h-8 w-60 animate-pulse bg-gray-300 text-xl text-blue-800 underline underline-offset-2' />
        </div>
        <div className='flex space-x-2'>
          <div className='relative h-8 w-8 animate-pulse rounded-full bg-gray-300' />
          <div className='relative h-8 w-8 animate-pulse rounded-full bg-gray-300' />
        </div>
      </div>
    </>
  );
}
